import React, { Component } from 'react';

import APIDocsCurl from 'common/developers/docs/api/APIDocsCurl';
import APIDocsMethod from 'common/developers/docs/api/APIDocsMethod';
import Highlight from 'common/developers/docs/api/Highlight';

import APIDocsBlock from '../APIDocsBlock';
import APIDocsTable from '../APIDocsTable';

export default class APIDocsListCategoriesBlock extends Component {
  createdAt = new Date();

  render() {
    return (
      <APIDocsBlock>
        <div>
          <div className="heading">List categories</div>
          <div className="text">
            Returns a list of categories. Include parameters to specify board and&nbsp;pagination.
            Sorted by newest.
          </div>
          <APIDocsTable
            title="Arguments"
            rows={[
              {
                description: 'Your secret API key.',
                heading: 'apiKey',
                subheading: 'string',
              },
              {
                description: "The id of the board you'd like to fetch categories for.",
                heading: 'boardID',
                subheading: 'string (optional)',
              },
              {
                description:
                  "The number of categories you'd like to fetch. Defaults to 10 if not specified. Max of 10000.",
                heading: 'limit',
                subheading: 'number (optional)',
              },
              {
                description:
                  "The number of categories you'd like to skip before starting to fetch. Defaults to 0 if not specified.",
                heading: 'skip',
                subheading: 'number (optional)',
              },
            ]}
          />
          <div className="subheading">Returns</div>
          <div className="text">
            A dictionary with a "categories" property that contains an array of tag objects. There's
            also a "hasMore" property that specifies whether this query returns more categories than
            the&nbsp;limit.
          </div>
        </div>
        <div>
          <div className="text">Endpoint</div>
          <Highlight lang="http">https://canny.io/api/v1/categories/list</Highlight>
          <APIDocsMethod />
          <APIDocsCurl
            path="https://canny.io/api/v1/categories/list"
            body={`\\
    -d apiKey=YOUR_API_KEY \\
    -d boardID=553c3ef8b8cdcd1501ba1234`}
          />
          <div className="text">Example Response</div>
          <Highlight lang="json">
            {`{
  "categories": [{
    "id": "553c3ef8b8cdcd1501ba12bb",
    "board": {
      "created": "${this.createdAt.toISOString()}",
      "id": "553c3ef8b8cdcd1501ba4400",
      "name": "Feature Requests",
      "postCount": 99,
      "url": "https://your-company.canny.io/admin/board/feature-requests"
    },
    "created": "${this.createdAt.toISOString()}",
    "name": "Example Category Name",
    "parentID": "552c3ef8b8cdcd1501ba12bb",
    "postCount": 12,
    "url": "https://your-company.canny.io/admin/board/feature-requests?category=example-category-name"
  }],
  "hasMore": false,
}`}
          </Highlight>
        </div>
      </APIDocsBlock>
    );
  }
}
